import { ALCHEMISTEN } from 'da-three';

import React, {Component} from 'react';
import './../../../css/login.css';

export default class Login extends Component{
    constructor(){
        super();

        this.state = {
            username: '',
            password: '',
            error: ''
        }
    }
    
    changePassword(event){
        this.setState({password: event.target.value});
    }
    
    changeUsername(event){
        this.setState({username: event.target.value});
    }
        
    login(event){
        event.preventDefault();
        ALCHEMISTEN.instance.auth.authUser(this.state.username,this.state.password,(error) => {
            if (error === null) {
                this.props.onSuccess();
            } else {
                this.setState({error: error.message});
            } 
        });
    }
        
    render(){
        return(
            <div id="loginPage">
                <div className="loginBox">
                    {this.state.error !== '' &&
                    <div className="errorMessage">
                        {this.state.error}
                    </div>
                    }
                    
                    <form onSubmit={(event) => this.login(event)}>
                        <input type="text" name="username" placeholder="Benutername" value={this.state.username} onChange={(event) => this.changeUsername(event)} required />
                        <input type="password" name="password" placeholder="Passwort" value={this.state.password} onChange={(event) => this.changePassword(event)} required />
                        <button type="submit">Login</button>
                    </form>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/login/components/login.component.js